<template>
  <div class="dropdown-menu-type-3">
    <div class="box">
      <button @click.stop="show" v-text="tempTitle"></button>
      <ul class="dropdown-box">
        <li
          v-for="(item, index) in tempData"
          v-bind:key="index"
          @click="selectMenu(index)"
          :class="{ 'active-item': tempIndex === index }"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as types from '../../store/mutation-types'
export default {
  name: 'dropdown-menu-type-3',
  props: {
    title: {
      default: 'SELECT',
      type: String
    },
    data: {
      default: () => ({
        1: {
          title: 'No data'
        }
      }),
      type: Object
    },
    baseUrl: {
      default: '/',
      type: String
    },
    query: {
      default: '',
      type: String
    },
    initIndex: {
      default: '',
      type: String
    },
    value: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      tempTitle: '',
      tempIndex: '',
      tempBaseUrl: ''
    }
  },
  created() {
    this.tempTitle = this.title
    this.tempBaseUrl = this.baseUrl
  },
  computed: {
    tempData() {
      return this.data
    }
  },
  methods: {
    generateBaseUrl() {
      if (this.query !== '') {
        this.tempBaseUrl += '?' + this.query + '=' + this.tempIndex
      }
    },
    /**
     * Click the button to display the corresponding child elements.
     * @param event
     */
    show(event) {
      this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear').then(() => {
        const el = event.target.nextElementSibling // Binding child element.
        if (el.className === 'dropdown-box') {
          el.className += ' active'
        } else {
          el.className = 'dropdown-box'
        }
      })
    },
    selectMenu(key) {
      this.tempTitle = this.data[key].title
      console.log(key, this.tempTitle)
      this.tempIndex = key
      this.$emit('input', key)
    },
    goToPage() {
      this.generateBaseUrl()
      console.log(this.tempBaseUrl)
      if (this.tempIndex !== '') {
        this.$router.push({ path: this.tempBaseUrl })
      } else {
        this.$router.push({ path: this.baseUrl })
      }
    }
  },
  watch: {
    initIndex: function(val) {
      console.log('watch initIndex:', val)
      this.selectMenu(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown-menu-type-3 {
  // Actions to prevent other stylesheets from affecting.
  text-align: left;
  position: relative;
  width: 100%;
  height: 50px;
  border: 1px solid #cbcbcb;
  background-color: white;

  button {
    cursor: pointer;
    border: 0;
    outline: none;
  }

  .box {
    height: 50px;
    width: 100%;

    button {
      background-color: white;
      background-image: url('../../assets/images/down-arrow.svg');
      background-position: 95% 50%;
      background-repeat: no-repeat;
      width: inherit;
      height: inherit;
      font-size: 16px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      text-align: left;
      letter-spacing: 1px;

      &:active {
        color: black;
      }
    }
    //noinspection ALL
    .dropdown-box {
      overflow-x: hidden;
      height: 0;
      z-index: -1;
      left: -1px;
      background-color: white;
      border: 1px solid #cbcbcb;
      width: inherit;
      position: absolute;
      margin-top: 2px;
      list-style: none;
      color: white;
      opacity: 0;
      visibility: hidden;
      padding: 10px 0;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;

      li {
        cursor: pointer;
        line-height: 30px;
        padding-left: 20px;
        color: black;
      }

      li:hover {
        color: black;
        background-color: #c6c6c6;

        transition-property: background-color transform transform color;
        transition-duration: 0.3s;
        transition-timing-function: ease-in-out;
      }

      .active-item {
        color: black;
        background-color: white;
      }
    }

    //noinspection ALL
    .active {
      height: 150px;
      z-index: 1000;
      opacity: 1;
      visibility: visible;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;
    }

    display: inline;
  }
}
</style>
